import { useMemo } from 'react';
import { GetCustomizeCar_customizeCar_availableFeatures as Feature } from '../../graphql/queries/__generated__/GetCustomizeCar';
import useCustomizeCarContext from '../useCustomizeCarContext';

export const useAvailableFeatures = (): {
  features: Feature[];
  loading: boolean;
} => {
  const { selectedCar, loading } = useCustomizeCarContext();

  const features = useMemo(() => selectedCar?.availableFeatures || [], [selectedCar]);

  return { features, loading };
};
